export enum CheckoutStatuses {
  SUCCESS = 'success',
  CANCEL = 'cancel',
  ERROR = 'error',
}

export enum CheckoutTypes {
  UPGRADE_DATA = 'upgrade_data',
  UPGRADE_TO_PRO = 'upgrade_to_pro',
  TRIAL = 'trial',
}
